import { z } from 'zod';
import { endpoint } from './endpoint.js';
import { PhotoDerivativeBackfillTriggerResponseSchema } from '../schemas/media-photo-derivatives.js';

export const adminPhotos = {
  /**
   * POST /admin/photos/backfill-derivatives
   *
   * Admin-only endpoint that enqueues a one-off, resumable backfill job to
   * generate thumb/display renditions for photos that pre-date the
   * media-photo-derivatives change. Guarded by `PermissionsGuard` +
   * `@RequirePermission('media_photo.backfill')`. Returns immediately with
   * the enqueued job ID; the job itself streams and processes in batches.
   */
  triggerBackfill: endpoint(
    'POST',
    '/admin/photos/backfill-derivatives',
    z.object({}),
    PhotoDerivativeBackfillTriggerResponseSchema,
  ),
};
